import { render, staticRenderFns } from "./expertiseSwiper.vue?vue&type=template&id=7ea30d55"
import script from "./expertiseSwiper.vue?vue&type=script&lang=js"
export * from "./expertiseSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports